import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0a193a] text-white/80 pt-20 pb-10 border-t border-white/10" data-id="element-61" data-mp="3ggka709t7m26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62" data-mp="32pfci3q053uh">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8 mb-16" data-id="element-63" data-mp="36oo9rik93jus">
          {/* Brand Col */}
          <div className="lg:col-span-4" data-id="element-64" data-mp="3ufjvpz20zku4">
            <div className="flex items-center gap-5 mb-6" data-id="element-65" data-mp="38quiv78flpl">
              <img src="https://cdn.magicpatterns.com/uploads/9pNo3tTwvFYBri2vFZFThu/Arissa_Cost_Solutions_Logo.png" alt="Arissa Cost Solutions" className="h-12 w-auto object-contain" data-id="element-66" data-mp="387e5ix8d5do" />
              <div className="flex items-center gap-3 pl-5 border-l border-white/15" data-id="element-67" data-mp="29zgjjx8osmkj">
                <a href="#" aria-label="Arissa Cost Solutions on LinkedIn" className="text-white/60 hover:text-brand-gold transition-colors" data-id="element-68" data-mp="2ey9zdwbg4pnv">
                  <Linkedin className="w-5 h-5" data-id="element-69" data-mp="3gapcti26iifg" />
                </a>
                <a href="#" aria-label="Arissa Cost Solutions on X" className="text-white/60 hover:text-brand-gold transition-colors" data-id="element-70" data-mp="3gck1n7gkmuot">
                  <Twitter className="w-5 h-5" data-id="element-71" data-mp="3qazp90ge3ltk" />
                </a>
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-sm" data-id="element-72" data-mp="33xd9vvh5urg">
              Helping employers navigate care for their injured workers. We
              provide highly integrated and comprehensive managed care services
              for Workers' Compensation and liability claims.
            </p>
            <img src="https://cdn.magicpatterns.com/uploads/hzJAvv5Vbr37BQ233epq9f/ArissaCS_Certs_-_FINAL_9.10.26.png" alt="URAC Accredited in Workers' Compensation Utilization Management and SOC 2 Type II tested and attested by Prescient Assurance" className="mt-8 w-full max-w-[260px] h-auto object-contain" data-id="element-73" data-mp="cw3617tjwg7p" />
          </div>

          {/* Services Col */}
          <div className="lg:col-span-3 lg:col-start-6" data-id="element-74" data-mp="13tke644cwbdz">
            <h4 className="text-white font-serif font-bold text-lg mb-6" data-id="element-75" data-mp="13rpoydm1xx43">
              Services
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-76" data-mp="18m3sx4es5ckd">
              <li data-id="element-77" data-mp="1cmdwkaf3nqw2">
                <Link to="/services/ancillary" className="hover:text-brand-gold transition-colors" data-id="element-78" data-mp="1ckt2sn0m0bz9">
                  A+ Ancillary Services
                </Link>
              </li>
              <li data-id="element-79" data-mp="1mhpfz61gdma5">
                <Link to="/services/bill-review" className="hover:text-brand-gold transition-colors" data-id="element-80" data-mp="1rilf76av0k98">
                  Medical Bill Review
                </Link>
              </li>
              <li data-id="element-81" data-mp="3tb9jzk35jfr4">
                <Link to="/services/case-management" className="hover:text-brand-gold transition-colors" data-id="element-82" data-mp="3tarquwbsdhnf">
                  Case Management
                </Link>
              </li>
              <li data-id="element-83" data-mp="21mtfu14qujyo">
                <Link to="/services/utilization-review" className="hover:text-brand-gold transition-colors" data-id="element-84" data-mp="21ma8tfgmtfzf">
                  Utilization Review
                </Link>
              </li>
              <li data-id="element-85" data-mp="2tdg2bd1ukffq">
                <Link to="/services/triage" className="hover:text-brand-gold transition-colors" data-id="element-86" data-mp="2tbvhwg98ycvl">
                  Medical Triage
                </Link>
              </li>
              <li className="pt-3 mt-3 border-t border-white/10" data-id="element-87" data-mp="2fe6vh3zj6xof">
                <Link to="/about" className="hover:text-brand-gold transition-colors font-semibold" data-id="element-88" data-mp="2fdymhn6j4cii">
                  About Us
                </Link>
              </li>
              <li data-id="element-89" data-mp="2rvr85h744sge">
                <Link to="/contact" className="hover:text-brand-gold transition-colors font-semibold" data-id="element-90" data-mp="2rv7pfy9n201b">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Col */}
          <div className="lg:col-span-4" data-id="element-91" data-mp="2nu5pff7wdjya">
            <h4 className="text-white font-serif font-bold text-lg mb-6" data-id="element-92" data-mp="2nuxkmoxl1fo1">
              Contact Us
            </h4>
            <ul className="space-y-4 text-sm" data-id="element-93" data-mp="3bk8fxqw5yhus">
              <li className="flex items-start" data-id="element-94" data-mp="3fl20caaedeix">
                <Phone className="w-5 h-5 mr-3 text-brand-gold flex-shrink-0" data-id="element-95" data-mp="3fksb4ox6fbea" />
                <div data-id="element-96" data-mp="31khk9lvv9wt4">
                  <div data-id="element-97" data-mp="31laskrah4udd">
                    <a href="tel:7142591053" className="hover:text-white transition-colors" data-id="element-98" data-mp="31nx1ovd0jhxp">
                      714.259.1053
                    </a>
                  </div>
                </div>
              </li>
              <li className="flex items-center" data-id="element-99" data-mp="1v6rvlpzhx4ie">
                <Mail className="w-5 h-5 mr-3 text-brand-gold flex-shrink-0" data-id="element-100" data-mp="1nlfxrh5hjkqq" />
                <a href="mailto:info@arissacs.com" className="hover:text-white transition-colors" data-id="element-101" data-mp="1imux5gmbmz1r">
                  info@arissacs.com
                </a>
              </li>
              <li className="flex items-start" data-id="element-102" data-mp="1rnb1steswc87">
                <MapPin className="w-5 h-5 mr-3 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-103" data-mp="1rlgc71sl3vxs" />
                <span data-id="element-104" data-mp="13y88goat0uxv">
                  Corporate Headquarters
                  <br data-id="element-105" data-mp="zxem3zd0fo73" />
                  2415 Campus Dr., Suite 250
                  <br data-id="element-106" data-mp="1dni248laqlo3" />
                  Irvine, CA 92612
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-white/50" data-id="element-107" data-mp="18uyo5aip5oir">
          <p data-id="element-108" data-mp="g8nsme9y6dst">
            &copy; {new Date().getFullYear()} Arissa Cost Solutions. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-109" data-mp="2g9lu5oshskeb">
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-110" data-mp="2l9qe5oslzx9a">
              Privacy Policy
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-111" data-mp="2q06t5dc2vqxr">
              Terms of Service
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-112" data-mp="2uz09ddir1w1m">
              Compliance
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}